import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles.css';
import axios from 'axios';

// Use API base URL from environment so relative auth calls (e.g. /auth/login)
// go to the backend instead of the React dev server.
axios.defaults.baseURL = process.env.REACT_APP_API_URL || '';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
